import React, { useEffect, useRef, useState } from "react"

import rightArrowImg from "../../images/new-pricing/right-arrow.svg"
import findMoreImg from "../../images/new-pricing/find-more.png"
import faqBorderImg from "../../images/new-pricing/faq-bh-border.svg"
import minusImg from "../../images/new-pricing/minus.svg"
import plusImg from "../../images/new-pricing/plus.svg"
import ReactGA from "react-ga"
import { standardFaq } from "../standard/faq"


export default function Demo({ activeTab, page }) {
  const [activeCollapse, setActiveCollapse] = useState(0)

  const toggleCollapse = (collapse) => {
    if (collapse === activeCollapse) {
      setActiveCollapse(0)
    } else {
      setActiveCollapse(collapse)
    }
    ReactGA.event({
      category: `${page}_Frequently Asked Questions`,
      action: `${page}_Frequently Asked Questions`,
    })
  }

  return (
    <div className="faq mx-auto">
      <div className="header relative">
        <div className="flex flex-col title">
          Frequently Asked Questions
          <img src={faqBorderImg} className="mx-auto" />
        </div>
        <div className="stick-img">
          <img src={rightArrowImg} />
          <div className="special-offer-text">
            <img src={findMoreImg} />
            {/*<span*/}
            {/*  className="text-neutral-3 custom-offer"> Find more answers to your <br /> questions by clicking </span>*/}
            {/*<span className="text-blue">here</span>*/}
          </div>
        </div>
      </div>
      <div className='faq-header-wrap'>
      {
        (activeTab === 1 ? soloFaq : standardFaq).map((data, index) => <div>
          <div className="faq-header flex items-center justify-between cursor-pointer"
               onClick={() => toggleCollapse(index + 1)}>
            {data.title}
            <div>
              {activeCollapse === index + 1 ? <img src={minusImg} />
                : <img src={plusImg} />}
            </div>
          </div>
          {activeCollapse === index + 1 &&
          <div className="content">
            {data.content}
          </div>}
        </div>)
      }
      </div>
    </div>
  )
}

const soloFaq = [
//   {
//   title: "Do both parties need to be LUCA PLUS subscribers before they can see the e-invoicing effect?",
//   content: <span>Both parties need to be on the LUCA Plus network or PEPPOL network to deliver e-invoices. <br /><br />
//     By doing so, we can ensure the other party is legitimate.<br /> The bonus is:<br />
//     <div className='ml-3'>
//     <ul>
//       <li className='list-disc list-inside'>You are being protected from potential fraudulent invoices and bills.</li>
//       <li className='list-disc list-inside'>It also allows simple and easy automation as both of you are part of the LUCA Plus network.</li>
//     </ul>
//     </div>
//   </span>,
// },
  {
    title: "What is LUCA Plus e-invoicing?",
    content: <span>LUCA Plus uses Electronic Invoicing (e-invoicing), which is a new way of sending invoices from software to software,
      saving businesses time and money by improving efficiency.<br /><br />LUCA Plus supports e-invoicing through the automated direct
      exchange of invoices between supplier and customer software systems. LUCA Plus allows invoices to be sent directly to a customer’s
      software system, regardless of accounting solution and is Australian Tax Office accredited.<br /><br />
      <span className="cursor-pointer" onClick={() => window.open("https://www.youtube.com/watch?v=2U-Zlt4pvQ4")}>Discover how easy it is to send an e-invoice with LUCA Plus.</span>.
    </span>,
  },
  {
    title: "How do I send and receive invoices?",
    content: <span>Sending and receiving invoices is a lot simpler with the Solo Plan. All you need to do is log in to LUCA Plus,
      choose the receiver, create an invoice and send it away.<br /><br />
      No need for any other software at your end.<br /><br />
      LUCA Plus will take care of all the technical details of your user receiving it securely in the correct format for whatever
      accounting software they choose to use.
</span>,
  },
]
